module.exports = __webpack_public_path__ + "img/column_yuwen1.daba5994.png";